module.exports = __webpack_public_path__ + "img/printExample.5199066e.gif";